import DatePicker from "react-datepicker";
import { MobileTimePicker } from "@mui/x-date-pickers/MobileTimePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { format } from "date-fns";
import { useState } from "react";
import { useFormContext } from "../FormProvider";
import Icons from "../../../../Constants/Icons";
import styles from "../../../Style";
import { Text } from "react-native";
import Switch from "@mui/material/Switch";
const DateTimePicker = () => {
  const { formData, setFormData, errors } = useFormContext();
  const [openPicker, setOpenPicker] = useState({
    DoorOpens: false,
    StartTime: false,
    EndTime: false,
  });

  const handleTimeChange = (key, newValue) => {
    const updatedTime =
      key === "StartTime"
        ? {
            StartTime: newValue,
            DoorOpens: dayjs(newValue).subtract(30, "minute"),
          }
        : { [key]: newValue };

    setFormData((prev) => ({ ...prev, ...updatedTime }));
  };

  const renderTimePicker = (key, label, icon) => (
    (
      <div
        className={`Category_name ${errors[key] ? "invalid" : "valid"}`}
        style={{ marginBottom: "0px", width: "100%" }}
      >
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <MobileTimePicker
            value={formData[key]}
            onChange={(newValue) => handleTimeChange(key, newValue)}
            open={openPicker[key]}
            onClose={() => setOpenPicker((prev) => ({ ...prev, [key]: false }))}
            // minTime={key === "EndTime" ? formData.DoorOpens : undefined}
            ampm
          />
          <div
            style={styles.startDate}
            onClick={() => setOpenPicker((prev) => ({ ...prev, [key]: true }))}
          >
            <img src={icon} style={{ height: "20px" }} alt={`${label} icon`} />
            <div className="fontSize16">
              {formData[key] ? (
                dayjs(formData[key]).format("hh:mm A")
              ) : (
                <div style={styles.customText_ad}>{label}</div>
              )}
            </div>
          </div>
        </LocalizationProvider>
      </div>
    )
  );
  
  return (
    <div>
      <div style={styles.EventDate}>
        <div
          className={`Category_name ${errors.ShowDate ? "invalid" : "valid"}`}
          style={{
            marginBottom: "20px",
            width: "100%",
            position: "relative",
            zIndex: 99,
          }}
        >
          <DatePicker
            selected={formData.ShowDate}
            minDate={new Date()}
            onChange={(date) =>
              setFormData((prev) => ({ ...prev, ShowDate: date }))
            }
            dateFormat="yyyy-MM-dd"
            className="p-2 border rounded w-full"
            onKeyDown={(e) => e.preventDefault()}
            customInput={
              <div style={styles.startDate}>
                <img
                  src={Icons.ic_date}
                  style={{ height: "20px" }}
                  alt="calendar icon"
                />
                <div className="fontSize16">
                  {formData.ShowDate ? (
                    format(new Date(formData.ShowDate), "MM/dd/yyyy")
                  ) : (
                    <div style={styles.customText_ad}>Show Date</div>
                  )}
                </div>
              </div>
            }
          />
        </div>

        {renderTimePicker("DoorOpens", "Door Opens", Icons.ic_door)}
      </div>
      <div style={styles.EventDate}>
        {renderTimePicker("StartTime", "Start Time", Icons.ic_time)}
        {renderTimePicker("EndTime", "End Time", Icons.ic_time)}
      
      </div>
      <div
        className="Switch_event"
        style={{ justifyContent: "end", marginLeft: "53%" }}
      >
        <Text style={styles.labelPhoto}>Mid-Night Show?</Text>
        <Switch
          color="primary"
          name="Status"
          onChange={() => {
            setFormData((prevForm) => ({
              ...prevForm,
              isMidNight: !formData.isMidNight,
            }));
          }}
          value={formData.isMidNight}
          checked={formData.isMidNight}
        />
      </div>
    </div>
  );
};

export default DateTimePicker;
